import { render, staticRenderFns } from "./FormMintNftContract.vue?vue&type=template&id=f64dc3d8&"
import script from "./FormMintNftContract.vue?vue&type=script&lang=js&"
export * from "./FormMintNftContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports